import styled from 'styled-components'
import { BaseTextArea } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const CheckRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 3px;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  margin-bottom: 7px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  width: 100%;
  padding: 8px;
  margin-top: 10px;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`

export const TextArea = styled(BaseTextArea)`
  width: 100%;
`

export const ImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  gap: 10px;
`

export const AddImageButton = styled.button.attrs ({
  type: 'button'
})`
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #CCCCCC;
  gap: 5px;

  label {
    line-height: 16px;
  }
`
